<template>
  <div>
    <v-navigation-drawer
      dark
      clipped
      :mini-variant="isMini"
      :mini-variant-width="miniMenuWidth"
      v-model="displayMenuModel"
      app
      :temporary="isSmartphoneMenu"
      mobile-breakpoint="960"
      width="300"
    >
      <v-card color="#1f8388" v-if="isSmartphoneMenu">
        <v-list-item v-if="!isAuthenticated" @click="loginExterne">
          <v-list-item-action>
            <v-icon>login</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Connexion Etudiant Externe</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!isAuthenticated" @click="login">
          <v-list-item-action>
            <v-icon>login</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Connexion Univ. de Lille</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-list>
        <div v-for="link in links" :key="link.name">
          <v-list-item :to="link.path" v-if="getLinkVisibility(link.meta)">
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div
          v-if="
            user != undefined &&
              user.roles.indexOf('ROLE_ADMIN') < 0 &&
              user.roles.indexOf('ROLE_SUAIO') > -1
          "
        >
          <v-list-item to="/boListFormations">
            <v-list-item-action>
              <v-icon>mdi-bookshelf</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Back-office</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div v-if="user != undefined && user.roles.indexOf('ROLE_ADMIN') > -1">
          <v-list-group :value="false" prepend-icon="mdi-library-shelves">
            <template v-slot:activator>
              <v-list-item-title>Back-office</v-list-item-title>
            </template>
            <v-list-item to="/boListFormations">
              <v-list-item-action>
                <v-icon small color="blue" right>mdi-bookshelf</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Formations</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/gestion-campus">
              <v-list-item-action>
                <v-icon small color="blue" right>mdi-bookshelf</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Campus</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/gestion-structures">
              <v-list-item-action>
                <v-icon small color="blue" right>mdi-bookshelf</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Structures</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/gestion-typePiece">
              <v-list-item-action>
                <v-icon small color="blue" right>mdi-bookshelf</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Types de pièce</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/gestion-referents-scolarite">
              <v-list-item-action>
                <v-icon small color="blue" right>mdi-bookshelf</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Référents scolarité</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>

      <v-card
        v-show="this.displayedArrow()"
        class="hidden-sm-and-down moving-arrow"
        :style="arrowStyle"
      ></v-card>

      <template v-slot:append>
        <div class="pa-2 text-center">
          <a href="https://www.univ-lille.fr" title="Université de Lille">
            <img :src="getLogoUrl(logo)" />
          </a>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BaseMenu",
  props: { displayMenu: Boolean, isSmartphoneMenu: Boolean, isMini: Boolean },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      // URL de connexion
      loginUrl:
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOGIN,

      activeLinkIndex: 0,
      activeLink: null,
      linkHeight: 48,
      logo: "logo.png"
    };
  },
  computed: {
    ...mapState(["user", "isAuthenticated"]),

    displayMenuModel: {
      get() {
        return this.displayMenu;
      },
      set(value) {
        this.$emit("update:displayMenu", value);
      }
    },
    miniMenuWidth() {
      if (this.isSmartphoneMenu) {
        return 63;
      }
      return 55;
    },

    arrowStyle() {
      var arrowMovePx = this.linkHeight * this.findActiveLinkPosition();
      return {
        transform: `translate3d(0px, ${arrowMovePx}px, 0px)`
      };
    },

    links() {
      return this.$router.options.routes;
    }
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true
    });

    if (this.isMini) {
      this.logo = "logo-extrasmall.png";
    }
  },
  methods: {
    // action login => envoie vers l'identification CAS via le backend de l'application
    login() {
      window.location = this.loginUrl;
    },

    loginExterne() {
      this.$router.push({
        name: "connexionExterieurs"
      });
    },

    displayedArrow() {
      if (this.activeLink) return this.activeLink.meta.menu;
    },

    findActiveLinkPosition() {
      var position = -1;

      this.$router.options.routes.forEach((link, index) => {
        if (index <= this.activeLinkIndex) {
          if (this.getLinkVisibility(link.meta)) {
            position++;
          }
        }
      });
      return position;
    },
    findActiveLink() {
      this.$router.options.routes.forEach((link, index) => {
        if (link.name == this.$route.name) {
          this.activeLinkIndex = index;
          this.activeLink = link;
        }
      });
    },
    getLogoUrl(logoName) {
      return require("@/assets/" + logoName);
    },
    getLinkVisibility(linkMetas) {
      if (!linkMetas.menu) {
        return false;
      } else {
        var linkVisibility = false;
        // aucune précison sur l'autorisation d'accès à cette route
        if (linkMetas.access === undefined) {
          linkVisibility = true;
        }
        // route publique (toujours autorisée)
        else if (linkMetas.access.type === "public") {
          linkVisibility = true;
        }
        // route accessible uniquement aux utilisateurs non-authentifiés
        else if (linkMetas.access.type === "anonymous") {
          // si l'utilisateur a accès et n'est pas authentifié
          if (!this.isAuthenticated) {
            linkVisibility = true;
          }
        }
        // route accessible uniquement aux utilisateurs authentifiés
        else if (linkMetas.access.type === "authenticated") {
          // si l'utilisateur est authentifié
          if (this.isAuthenticated) {
            linkVisibility = true;
            // pour chaque rôle de l'utilisateur,
            // on teste sa présence dans la liste des rôles autorisés à accéder à cette route
            if (Array.isArray(linkMetas.access.roles)) {
              linkVisibility = false;
              if (Array.isArray(this.user.roles)) {
                this.user.roles.forEach(userRole => {
                  if (linkMetas.access.roles.indexOf(userRole) > -1) {
                    linkVisibility = true;
                  }
                });
              }
            }
          }
        }
        return linkVisibility;
      }
    }
  }
};
</script>

<style scoped>
.v-application a.v-list-item--active {
  color: #ffffff;
}
.v-list-item__title {
  font-size: 0.9em;
}

div.moving-arrow.v-card {
  box-shadow: none;
  background-color: transparent;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  display: inline-block;
  position: absolute;
  left: 284px;
  top: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1);
  z-index: 1;
}

.v-application.theme--light div.moving-arrow.v-card {
  border-right: 17px solid #ededed !important;
}

.v-application.theme--dark div.moving-arrow.v-card {
  border-right: 17px solid #121212 !important;
}
</style>
